//возвращает ширину скрола
function getWidth() {
  var block = $('<div>').css({'height':'50px','width':'50px'}),
      indicator = $('<div>').css({'height':'200px'});

  $('body').append(block.append(indicator));
  var w1 = $('div', block).innerWidth();
  block.css('overflow-y', 'scroll');
  var w2 = $('div', block).innerWidth();
  $(block).remove();
  return (w1 - w2);
}


//проверяет есть ли скролл на странице
function isActive() {
  return (document.body.offsetHeight > window.innerHeight ? true : false);
}

export default {
  getWidth: getWidth,
  isActive: isActive
};


// WEBPACK FOOTER //
// ./components/scrollbar.js